<template>
    <div id="app">
        <keep-alive>
            <router-view name="navBar"/>
        </keep-alive>
        <!-- 路由的出口 -->
        <!-- <router-view/> -->
        <keep-alive>
            <router-view v-if="keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!keepAlive"></router-view>
        <LoginDialog :show.sync="loginDialogShow"></LoginDialog>
        <keep-alive>
            <router-view name="footer"/>
        </keep-alive>
    </div>
</template>

<script>
import LoginDialog from "./components/loginDiolog";
export default {
    name: "App",
    components: {
        LoginDialog,
    },
    mounted() {
        this.$bus.$on("login", this.openLogin);
    },
    destroyed() {
        this.$bus.$off("login", this.openLogin);
    },
    data() {
        return {
            loginDialogShow: false,
        }
    },
    computed: {
        keepAlive() {
            return this.$route.meta.keepAlive
        }
    },
    methods: {
        openLogin() {
            this.loginDialogShow = true;
        }
    },
}
</script>

<style lang="less"></style>
